import { render, staticRenderFns } from "./Section8.vue?vue&type=template&id=79646118&scoped=true&"
import script from "./Section8.vue?vue&type=script&lang=js&"
export * from "./Section8.vue?vue&type=script&lang=js&"
import style0 from "./Section8.vue?vue&type=style&index=0&id=79646118&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79646118",
  null
  
)

export default component.exports